import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@/inversify.config';
import { CategoryApi as CategoryApiToken } from './types/category-api.interface';
let CategoryServiceImpl = class CategoryServiceImpl {
    constructor(_categoryApi) {
        this._categoryApi = _categoryApi;
    }
    checkCache(spaceId, folderId) {
        return this._categoryApi.checkCache(spaceId, folderId);
    }
    submitTask(spaceId, folderId) {
        return this._categoryApi.submitTask(spaceId, folderId);
    }
    pollResult(spaceId, folderId) {
        return this._categoryApi.pollResult(spaceId, folderId);
    }
};
CategoryServiceImpl = __decorate([
    injectable(),
    __param(0, inject(CategoryApiToken)),
    __metadata("design:paramtypes", [Object])
], CategoryServiceImpl);
export { CategoryServiceImpl };
